import { CodeWorkflowType, WorkflowTriggerAction, WorkflowTriggerPhase } from "../../../../types/rubric";

export const SPAN_ANSWERED_ID = -3;
export const SPAN_NOT_ANSWERED_ID = -4;

// Cross-workflow targets are AUTOFILL-only for now. To enable another
// action, add it here and to cqa-service's matching allowlist only after
// backend persistence/runtime semantics and UI/backend/e2e coverage exist.
export const CROSS_WORKFLOW_TARGET_ACTIONS = new Set<WorkflowTriggerAction>([
    WorkflowTriggerAction.AUTOFILL,
]);

export const supportsCrossWorkflowTargets = (
    action: WorkflowTriggerAction | undefined | null,
): boolean => action != null && CROSS_WORKFLOW_TARGET_ACTIONS.has(action);

// Cross-workflow source actions for SPAN-typed host workflows.
// PRE SHOW_QUESTION visibility rules can resolve their source question
// against CASE/code-level sibling workflows. Legacy POST GO_TO/STOP remain
// ordinary workflow triggers and stay host-workflow scoped.
export const CROSS_WORKFLOW_SOURCE_ACTIONS = new Set<WorkflowTriggerAction>([
    WorkflowTriggerAction.SHOW_QUESTION,
]);

export const supportsCrossWorkflowSources = (
    action: WorkflowTriggerAction | undefined | null,
    triggerPhase?: WorkflowTriggerPhase | null,
    hostCodeType?: CodeWorkflowType | null,
): boolean =>
    hostCodeType === "SPAN" &&
    triggerPhase === "PRE" &&
    action != null &&
    CROSS_WORKFLOW_SOURCE_ACTIONS.has(action);
